import React from 'react'
import { Form, Radio, Col } from 'antd'
import '../index.css'


const FormItem = Form.Item

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

class DkqkInitForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initFlag: false,
            sfdqjt: "否",
            sfgexs: "否",
        }
    }

    componentDidMount() {
        const { dkqkInitData = {} } = this.props;
        this.setState({
            sfdqjt: dkqkInitData.isDq || "否",
            sfgexs: dkqkInitData.isGe || "否",
        }, () => {
            if(!dkqkInitData.familyList || dkqkInitData.familyList.length === 0) {
                this.handleChange();
            }
        })
    }

    handleChange = () => {
        const { onChange } = this.props;
        const { sfdqjt, sfgexs } = this.state;
        let grqk = "0";
        if (sfdqjt == '是') {
            grqk = "1"; // 单亲家庭
        } else if (sfgexs == '是') {
            grqk = "2"; // 孤儿
        }
        typeof onChange === 'function' && onChange(grqk)
    }

    // 是否单亲家庭
    onSfdqjtChange = (e) => {
        const { form } = this.props;
        const value = e.target.value;
        this.setState({
            sfdqjt: value,
            sfgexs: value == '是' ? "否" : this.state.sfgexs
        }, () => {
            form.setFieldsValue({
                isGe: this.state.sfgexs
            })
            this.handleChange();
        })
    }
    // 是否孤儿学生
    onSfgexsChange = (e) => {
        const { form } = this.props;
        const value = e.target.value;
        this.setState({
            sfgexs: value,
            sfdqjt: value == '是' ? "否" : this.state.sfdqjt
        }, () => {
            form.setFieldsValue({
                isDq: this.state.sfdqjt
            })
            this.handleChange();
        })
    }

    render() {
        const { sfdqjt, sfgexs } = this.state
        const { getFieldDecorator } = this.props.form;
        const { form, isRequired, editable } = this.props

        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ height: '18px', width: '3px', borderRadius: '20px', background: '#066DBF' }}></div>
                    <div styleName="title_top_name" style={{ borderLeft: 0 }}>
                        <span><span style={{ display: isRequired ? '' : 'none', color: 'red' }}>*</span>个人信息</span>
                    </div>
                </div>

                <div className="p-sw" >
                    <Form>
                        <div className="p-sw">
                             <FormItem
                                {...formItemLayout}
                                label="是否为单亲家庭子女"
                            >
                                {getFieldDecorator('isDq', {
                                    initialValue: sfdqjt,
                                    rules: [
                                        {
                                            required: true,
                                            message: "请选择"
                                        }],
                                })(
                                    editable ?
                                        <Radio.Group onChange={this.onSfdqjtChange}>
                                            <Radio value={"是"}>是</Radio>
                                            <Radio value={"否"}>否</Radio>
                                        </Radio.Group>
                                        : <span>{sfdqjt ? sfdqjt : '未填写'}</span>
                                )}
                            </FormItem>
                             <FormItem
                                {...formItemLayout}
                                label="是否为孤儿学生"
                            >
                                {getFieldDecorator('isGe', {
                                    initialValue: sfgexs,
                                    rules: [
                                        {
                                            required: true,
                                            message: "请选择"
                                        }],
                                })(
                                    editable ?
                                        <Radio.Group onChange={this.onSfgexsChange}>
                                            <Radio value={"是"}>是</Radio>
                                            <Radio value={"否"}>否</Radio>
                                        </Radio.Group> : <span>{sfgexs ? sfgexs : '未填写'}</span>
                                )}
                            </FormItem>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default DkqkInitForm
